<template>
<v-app>
  <v-main>
    <v-sheet max-width="550" class="mx-auto h-100" color="Greyscale_002">
      <navbar-component />
      <div class="py-4">
        <router-view />
      </div>
    </v-sheet>
  </v-main>
</v-app>
</template>
<script>
  import NavbarComponent from "/src/resources/components/guest/navbar.component.vue";
  export default {
    components: {
        NavbarComponent,
    },
    mounted() {},
  };
</script>